export default "__VITE_ASSET__PFJsW9B0__"